/* HitchFire special-offer landing page. External on purpose: the vsly
   (Visually.io) A/B test mangles inline section scripts. Drives nav/sticky
   state, scroll reveal, hero video, the YouTube facade, live Yotpo reviews
   and dataLayer events for the offer CTAs. */
(function () {
  'use strict';
  function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; }
  function stars(n) { n = Math.round(n || 0); var o = ''; for (var i = 1; i <= 5; i++) o += i <= n ? '★' : '<span class="off">★</span>'; return o; }
  function clamp(t, n) { t = String(t || '').replace(/\s+/g, ' ').trim(); return t.length > n ? t.slice(0, n).replace(/\s+\S*$/, '') + '…' : t; }
  function push(o) { try { (window.dataLayer = window.dataLayer || []).push(o); } catch (e) {} }

  function init(root) {
    if (!root || root.getAttribute('data-hfso-done') === '1') return;
    root.setAttribute('data-hfso-done', '1');
    root.classList.add('js');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* nav solidify + sticky bar */
    var nav = root.querySelector('[data-hfso-nav]');
    var bar = root.querySelector('[data-hfso-sticky]');
    var ticking = false;
    function onScroll() {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () {
        var y = window.scrollY || window.pageYOffset;
        if (nav) nav.classList.toggle('solid', y > 72);
        if (bar) bar.classList.toggle('on', y > window.innerHeight * 0.8);
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    /* scroll reveal */
    var rv = root.querySelectorAll('.rv');
    if (reduce || !('IntersectionObserver' in window)) {
      for (var i = 0; i < rv.length; i++) rv[i].classList.add('in');
    } else {
      var obs = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); obs.unobserve(e.target); } });
      }, { threshold: 0.1, rootMargin: '0px 0px -48px 0px' });
      for (var j = 0; j < rv.length; j++) obs.observe(rv[j]);
    }

    /* hero video: force muted loop, fall back to poster */
    var v = root.querySelector('[data-hfso-video]');
    if (v) {
      v.muted = true; v.defaultMuted = true; v.loop = true;
      if (reduce) { v.removeAttribute('autoplay'); v.pause(); }
      else {
        v.addEventListener('ended', function () { v.currentTime = 0; v.play().catch(function () {}); });
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      }
    }

    /* YouTube facade: iframe only after click */
    var yt = root.querySelector('[data-hfso-yt]');
    if (yt) {
      yt.addEventListener('click', function () {
        var id = yt.getAttribute('data-hfso-yt');
        var f = document.createElement('iframe');
        f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
        f.title = yt.getAttribute('aria-label') || 'Product video';
        f.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
        f.setAttribute('allowfullscreen', '');
        yt.parentNode.replaceChild(f, yt);
        push({ event: 'hfso_video_play', hfso_offer: root.getAttribute('data-offer') });
      });
    }

    /* CTA tracking */
    root.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-hfso-cta]');
      if (!a) return;
      push({ event: 'hfso_cta_click', hfso_offer: root.getAttribute('data-offer'), hfso_cta: a.getAttribute('data-hfso-cta'), hfso_checkout: a.hasAttribute('data-hfso-checkout') });
    });

    /* live Yotpo reviews — real reviews only; sections stay hidden when none qualify */
    var rev = root.querySelector('[data-hfso-reviews]');
    var quote = root.querySelector('[data-hfso-quote]');
    var key = root.getAttribute('data-yotpo-key');
    var pid = root.getAttribute('data-yotpo-pid');
    if ((rev || quote) && key && pid) {
      fetch('https://api-cdn.yotpo.com/v1/widget/' + encodeURIComponent(key) + '/products/' + encodeURIComponent(pid) + '/reviews.json?per_page=100&page=1&sort=date&direction=desc')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var res = (data && data.response) || {};
          var bl = res.bottomline || {};
          var list = (res.reviews || []).filter(function (r) { return r && r.score >= 4 && r.content && r.content.replace(/\s+/g, ' ').trim().length > 40; });
          list.sort(function (a, b) { return b.content.length - a.content.length; });
          if (!list.length) return;
          function who(r) { return (r.user && (r.user.display_name || r.user.name)) || r.name || 'Verified owner'; }
          if (quote) {
            var q = list[0];
            quote.querySelector('[data-q]').innerHTML = '<div class="stars" aria-label="Rated ' + q.score + ' out of 5">' + stars(q.score) + '</div><p>“' + esc(clamp(q.content, 280)) + '”</p><div class="by">' + esc(who(q)) + (q.verified_buyer ? ' · Verified Buyer' : '') + '</div>';
            quote.hidden = false;
          }
          if (rev) {
            var lim = parseInt(rev.getAttribute('data-limit'), 10) || 3;
            var pick = list.slice(quote && list.length > lim ? 1 : 0).slice(0, lim);
            rev.querySelector('[data-grid]').innerHTML = pick.map(function (r, k) {
              return '<blockquote class="hfso-rc rv in d' + (k + 1) + '"><div class="stars" aria-label="Rated ' + r.score + ' out of 5">' + stars(r.score) + '</div><p>“' + esc(clamp(r.content, 300)) + '”</p><footer><div class="nm">' + esc(who(r)) + '</div><div class="mt">' + (r.verified_buyer ? 'Verified Buyer' : 'Owner review') + (r.created_at ? ' · ' + new Date(r.created_at).toLocaleDateString('en-US', { month: 'short', year: 'numeric' }) : '') + '</div></footer></blockquote>';
            }).join('');
            var total = bl.total_review || bl.total_reviews;
            var agg = rev.querySelector('[data-agg]');
            if (total && agg) {
              var avg = Math.round((bl.average_score || 0) * 10) / 10;
              agg.innerHTML = '<span class="stars" aria-hidden="true">' + stars(avg) + '</span><span>' + avg + ' / 5 · ' + total + ' review' + (total === 1 ? '' : 's') + '</span>';
              agg.hidden = false;
            }
            rev.hidden = false;
          }
        })
        .catch(function () {});
    }
  }

  function boot() { var r = document.querySelectorAll('[data-hfso]'); for (var i = 0; i < r.length; i++) init(r[i]); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();